export default {
  dashboard: () => import("/home/circleci/reflect-front/layouts/dashboard.vue").then(m => m.default || m),
  default: () => import("/home/circleci/reflect-front/layouts/default.vue").then(m => m.default || m),
  "legal-reports": () => import("/home/circleci/reflect-front/layouts/legal-reports.vue").then(m => m.default || m),
  settings: () => import("/home/circleci/reflect-front/layouts/settings.vue").then(m => m.default || m)
}